module.exports = __webpack_public_path__ + "img/quility-logo-r.70b75def.svg";